import { Injectable } from '@angular/core';
import { UserInfo } from '../models/auth.model';
import { HttpClient } from '@angular/common/http';
import { ResponseHTTP } from '../models/response-http.models'
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import env  from  '../environments/enviorments'
import { Area } from '../models/area.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor (
    private http:HttpClient
  ){}

  saveArea(area: Area): void {
    const areaString = JSON.stringify(area);
    localStorage.setItem('area', areaString);
  }

  deleteArea(): void {
    localStorage.removeItem('area');
  }

  getArea(): Area {
    const areaString = localStorage.getItem('area');
    return areaString ? JSON.parse(areaString) : null;
  }

  saveUser(user: UserInfo): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  deleteUser(): void {
    localStorage.removeItem('user');
  }
  getUser(): UserInfo  {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }
  removeUser(): void  {
    localStorage.removeItem('user')
  }
  getUserNPass(){
    // return this.http.get(`${this.apiUrl}/endpoint`)
    return ''
  }

  authUser(username: string, password: string): Observable<any> {
    return this.http.post<ResponseHTTP>(`${env.apiUrl}/auth/login/`, { username, password })
      .pipe(
        map((response: ResponseHTTP) => {
          return response;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
  mfaCompare(mfaCode: string, userId: number): Observable<ResponseHTTP> {
    return this.http.post<ResponseHTTP>(`${env.apiUrl}/auth/mfa/`, { mfaCode:mfaCode, userId:userId })
      .pipe(
        map((response: ResponseHTTP) => {
          return response;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  // Forgot Password
  findUserNMail(username: string, email: string): Observable<ResponseHTTP> {
    return this.http.post<ResponseHTTP>(`${env.apiUrl}/auth/findUser/`, { username, email })
      .pipe(
        map((response: ResponseHTTP) => {
          return response.message;
        }),
        catchError((error) => {
          console.error("Error:", error);
          throw error;
        })
      );
  }

  sendCodeToChangePass(username: string, email: string): Observable<ResponseHTTP> {
    return this.http.post<ResponseHTTP>(`${env.apiUrl}/auth/sendCode/`, { username, email })
      .pipe(
        map((response: ResponseHTTP) => {
          return response.code;
        }),
        catchError((error) => {
          console.error("Error:", error);
          throw error;
        })
      );
  }

  compareOldPass(username: string, email:string, password: string): Observable<ResponseHTTP> {
    const body = { username, email, password };
    return this.http.post<ResponseHTTP>(`${env.apiUrl}/auth/compareOldPass/`, body)
      .pipe(
        map((response: ResponseHTTP) => {
          return response;
        }),
        catchError((error) => {
          throw error;
        })
      );
  }

  changePass(username: string, email:string, password: string): Observable<ResponseHTTP> {
    return this.http.post<ResponseHTTP>(`${env.apiUrl}/auth/changePassword/`, { username, email, password})
      .pipe(
        map((response: ResponseHTTP) => {
          return response;
        }),
        catchError((error) => {
          throw error;
        })
      );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async tokenValidation(token: string): Promise<any> {
    return this.http.post<ResponseHTTP>(`${env.apiUrl}/auth/token/`, { token:token }).toPromise()
  }
}

